import React from "react";

type Reference = { title: string; url: string };

type GenericCardProps = {
  image?: string;
  title: string;
  subtitle?: string;
  region?: string;
  fields: { label: string; value: string }[];
  references: Reference[];
  darkMode?: boolean;
};

const GenericCard = ({
  image,
  title,
  subtitle,
  region,
  fields,
  references,
  darkMode = false,
}: GenericCardProps) => {
  return (
    <div
      className={`${
        darkMode ? "bg-gray-800 border border-gray-700" : "bg-white"
      } rounded-xl shadow p-4 hover:shadow-lg transition-shadow flex flex-col`}
    >
      <div className="aspect-video w-full overflow-hidden rounded-lg mb-2">
        <img
          src={image || "/placeholder.svg"}
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex justify-between items-start mb-2">
        <div
          className={`text-xl font-bold ${
            darkMode ? "text-orange-200" : "text-orange-800"
          }`}
        >
          {title}
        </div>
        {region && (
          <span
            className={`${
              darkMode
                ? "bg-orange-900 text-orange-200"
                : "bg-orange-200 text-orange-800"
            } text-xs px-2 py-1 rounded`}
          >
            {region}
          </span>
        )}
      </div>
      {subtitle && (
        <div
          className={`text-sm mb-2 ${
            darkMode ? "text-gray-300" : "text-gray-500"
          }`}
        >
          {subtitle}
        </div>
      )}
      {fields.map((field, idx) => (
        <div className="mb-2" key={idx}>
          <div
            className={`font-semibold ${
              darkMode ? "text-gray-200" : "text-gray-700"
            }`}
          >
            {field.label}:
          </div>
          <div
            className={
              field.label === "Makna" || field.label === "Pesan Moral"
                ? `${
                    darkMode ? "text-orange-300" : "text-orange-700"
                  } text-sm font-medium`
                : `${darkMode ? "text-gray-300" : "text-gray-600"} text-sm`
            }
          >
            {field.value}
          </div>
        </div>
      ))}
      <div>
        <div
          className={`font-semibold ${
            darkMode ? "text-gray-200" : "text-gray-700"
          }`}
        >
          Referensi:
        </div>
        <ul
          className={`text-xs space-y-1 ${
            darkMode ? "text-gray-400" : "text-gray-500"
          }`}
        >
          {references.map((ref, refIndex) => (
            <li key={refIndex}>
              •{" "}
              <a
                href={ref.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${
                  darkMode ? "text-blue-300" : "text-blue-600"
                } underline`}
              >
                {ref.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GenericCard;
